<div>
  <div class="search-bar">
    <div>
      <span>{{ 'pages.movements_list.recent_movs' | translate }}</span>
    </div>
  </div>
  <div class="movement-list">
    <div *ngIf="!loading && noMovements">
      <span>{{ 'pages.movements_list.no_movements' | translate }}</span>
    </div>
    <div
      class="movement-card-container"
      *ngFor="let element of filterMovs | paginate : { itemsPerPage: 5, currentPage: pageActual }"
      (click)="clickInAction(element, { id: 1, name: 'pageview', path: 'detail-pay', status: true, type: 'action' })"
    >
      <div class="container-cuit-cvu-titulo">
        <span
          style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: 600"
          [innerHTML]="element.titulo"
        ></span>
        <span [ngClass]="setClassEstado(element.estado)">{{ element.estado }}</span>
      </div>

      <div class="container-importe-estado-hora">
        <div class="importe-estado">
          <span>{{ maskPrice(element.importe) }}</span>
        </div>

        <div class="fecha-hora">
          <span style="font-weight: bold">{{ element.fecha | date : 'd/M/yy' }}</span>
          <span>{{ element.fecha | date : 'H:mm' }} h</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loading" style="width: 100%; display: flex; justify-content: center">
    <img style="border-radius: 57px" src="assets/icons/logo-fiser-loading.gif" alt="" width="150px" />
  </div>
  <div *ngIf="!loading && !noMovements" class="show-all-movements">
    <span (click)="goToMovements()"><b style="color: #ff6600">Ver todos tus movimientos</b></span>
  </div>
</div>
